import * as React from 'react';
import { SVGProps } from 'react';

const IconRingSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 1a1 1 0 0 0-.992 1.124A4.002 4.002 0 0 0 4 6v3a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2V6a4.002 4.002 0 0 0-3.008-3.876A1 1 0 0 0 8 1zm2 11a2 2 0 1 1-4 0h4z" />
  </svg>
);
export default IconRingSizeS;
